import type { CheckboxProps } from '@ariakit/react';
import { Checkbox, useCheckboxStore } from '@ariakit/react';

import { Box } from '../Box/Box';
import type { IconProps } from '../icons';
import { Text } from '../Text/Text';

import * as styles from './styles.css';

type Props = Omit<CheckboxProps, 'size'> &
  styles.Variants & {
    iconLeft?: React.ReactElement<IconProps>;
    iconRight?: React.ReactElement<IconProps>;
  };

export const SwitchButton: React.FC<React.PropsWithChildren<Props>> = ({
  onChange,
  checked,
  size,
  iconLeft,
  iconRight,
  children,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const className = styles.variants({
    size,
    variant: checked ? 'checked' : 'unchecked',
  });
  const checkbox = useCheckboxStore();

  return (
    <Checkbox
      render={<button aria-label={ariaLabel} />}
      className={className}
      store={checkbox}
      onChange={onChange}
      checked={checked}
      aria-label={ariaLabel}
      {...rest}
    >
      {iconLeft && (
        <Box as="span" display="inline-flex">
          {iconLeft}
        </Box>
      )}
      {children && <Text size="xSmall">{children}</Text>}
      {iconRight && (
        <Box as="span" display="inline-flex">
          {iconRight}
        </Box>
      )}
    </Checkbox>
  );
};
